import {
  GET_POINT_REDEMPTION_USAGE,
  GetAllPointRedemptionUsages as getAllPointRedemptionUsagesQuery,
} from "_graphql/visal/queries/point-redemptions";
import {
  GetAllPointRedemptionUsages,
  GetAllPointRedemptionUsagesVariables,
} from "_graphql/queries/__generated__/getAllPointRedemptionUsages";
import {
  GetPointRedemptionUsage,
  GetPointRedemptionUsageVariables,
} from "_graphql/queries/__generated__/getPointRedemptionUsage";

import { useQuery } from "@apollo/client";

export const usePointRedemptionUsages = ({
  brokerId,
}: {
  brokerId: string;
}) => {
  const { data, loading, error, refetch } = useQuery<
    GetAllPointRedemptionUsages,
    GetAllPointRedemptionUsagesVariables
  >(getAllPointRedemptionUsagesQuery, {
    variables: {
      broker_id: brokerId,
    },
    fetchPolicy: "network-only",
    skip: !brokerId,
  });

  return {
    redemptions: data?.getAllPointRedemptionUsages || [],
    loading,
    error,
    refetch,
  };
};

export const usePendingPointRedemptionUsages = ({
  brokerId,
}: {
  brokerId: string;
}) => {
  const { data, loading, error, refetch } = useQuery<
    GetAllPointRedemptionUsages,
    GetAllPointRedemptionUsagesVariables
  >(getAllPointRedemptionUsagesQuery, {
    variables: {
      broker_id: brokerId,
    },
    fetchPolicy: "network-only",
    skip: !brokerId,
  });

  const pendingRedemptions =
    data?.getAllPointRedemptionUsages?.filter(
      (redemption) => redemption.status === "PENDING"
    ) || [];

  return {
    redemptions: pendingRedemptions || [],
    loading,
    error,
    refetch,
  };
};

export const usePointRedemptionUsage = ({
  redemptionId,
}: {
  redemptionId: string;
}) => {
  const { data, loading, error, refetch } = useQuery<
    GetPointRedemptionUsage,
    GetPointRedemptionUsageVariables
  >(GET_POINT_REDEMPTION_USAGE, {
    variables: {
      redemption_id: redemptionId,
    },
    fetchPolicy: "network-only",
    skip: !redemptionId,
  });

  return {
    redemption: data?.getPointRedemptionUsage || null,
    loading,
    error,
    refetch,
  };
};
